// extracted by mini-css-extract-plugin
export var columnItem = "_bj-3";
export var columnItemDraggable = "_bj-4";
export var dragHandle = "_bj-0";
export var dragHandleHovered = "_bj-1";
export var dropdown = "_bj-5";
export var dropdownContent = "_bj-7";
export var dropdownInner = "_bj-6";
export var filterDropdownHeader = "_bj-8";
export var icon = "_bj-2";
export var sectionDivider = "_bj-9";